import clsx from 'clsx';

const variants = {
  active:   'badge-success',
  inactive: 'badge-neutral',
  archived: 'badge-warning',
  success:  'badge-success',
  warning:  'badge-warning',
  error:    'badge-danger',
  danger:   'badge-danger',
  info:     'badge-info',
  default:  'badge-neutral',
};

export default function Badge({ label, variant = 'default', className }) {
  return (
    <span className={clsx('badge', variants[variant] ?? variants.default, className)}>
      {label}
    </span>
  );
}
